import React, { Component } from "react";
import PropTypes from "prop-types";
import MenuItem from "material-ui/MenuItem";
import RaisedButton from "material-ui/RaisedButton";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";

class TestDatePicker extends Component {
  state = {
    open: false,
  };

  handleOpen = (e) => {
    e.preventDefault();
    this.setState({
      open: true,
      anchorEl: e.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleClick = (Visibility) => {
    const { handleVisibility } = this.props;
    this.handleClose();
    handleVisibility(Visibility);
  };

  render() {
    const { open, anchorEl } = this.state;

    return (
      <div>
        <RaisedButton
          onClick={this.handleOpen}
          label="Visibilité"
          className="practice-button"
        />
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          onRequestClose={this.handleClose}
        >
          <Menu>
            <MenuItem
              onClick={() => this.handleClick(true)}
              primaryText="Tous visibles"
            />
            <MenuItem
              onClick={() => this.handleClick(false)}
              primaryText="Tous invisibles"
            />
          </Menu>
        </Popover>
      </div>
    );
  }
}

TestDatePicker.propTypes = {
  handleChange: PropTypes.func,
};

export default TestDatePicker;
